import React from 'react';
import { WarningModalName } from './config';
import ConfirmOpenModal from './ConfirmOpenModal';

const noop = () => {};

const WalletConnectConfirmContext = /*#__PURE__*/React.createContext({
  confirmOpenWalletConnect: noop,
  openModal: noop,
  closeModal: noop
});

const WalletConnectConfirmProvider = ({
  children
}) => {
  const [modal, setModal] = React.useState(null);
  const [handlerRef, setHandlerRef] = React.useState(null);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setModal(null);
    setHandlerRef(null);
  }, []);

  const confirmOpenWalletConnect = handler => {
    setHandlerRef({
      handler
    });
    setModal(WarningModalName.CONFIRM_OPEN);
  };

  const context = React.useMemo(() => {
    return {
      modal: modal || undefined,
      openModal,
      closeModal,
      confirmOpenWalletConnect: confirmOpenWalletConnect
    };
  }, [modal]); // Render the current modal

  const renderModal = () => {
    switch (modal) {
      case WarningModalName.CONFIRM_OPEN:
        return !!handlerRef && /*#__PURE__*/React.createElement(ConfirmOpenModal, {
          onClick: () => {
            if (typeof handlerRef.handler === 'function') {
              handlerRef.handler();
              closeModal();
            }
          }
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(WalletConnectConfirmContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useConfirmOpenWalletConnect = () => {
  const {
    modal,
    confirmOpenWalletConnect
  } = React.useContext(WalletConnectConfirmContext);
  return {
    modal,
    confirmOpenWalletConnect
  };
};
export default WalletConnectConfirmProvider;